import { scrollytelling } from './initializeStats';
import { statsArticle } from './statsArticle';
import { inViewport } from './elementsInViewport';
import { linkStats, setStatElementCollector, shareStats } from './stats';
import { wideo } from './wideo';
import { menu } from './menu';
import { anchors } from './anchors';

// const debounce = (func, delay = 1000) => {
//   let timeoutId;
//   return (...args) => {
//     if (timeoutId) {
//       clearTimeout(timeoutId);
//     }
//     timeoutId = setTimeout(() => {
//       func(...args);
//     }, delay);
//   };
// };
anchors();
statsArticle();
setStatElementCollector();
linkStats();
inViewport();
shareStats();
wideo();
menu();

window.addEventListener('beforeunload', scrollytelling.unloadData.bind(scrollytelling));

// for testing
// document.querySelector('.header').addEventListener('click', scrollytelling.unloadData.bind(scrollytelling));
